import React from 'react'
import List from 'components/Common/List'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import MarkdownRender from 'LuxKit/MarkdownRender'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineArrowsRightDownIcon from 'LuxKit/Icons/line/LineArrowsRightDownIcon'
import { useIntl } from 'react-intl'

interface Props {
  pkg: App.Package
}

function FlashHotelAboutRoomModalTab(props: Props) {
  const { pkg } = props
  const intl = useIntl()

  const amenities = pkg.roomType?.amenities
  const policyDescription = pkg.roomPolicyDescription

  return (
    <Group direction="vertical" gap={32}>
      {!!pkg.roomType?.description && <BodyText variant="medium">{pkg.roomType?.description}</BodyText>}
      <Group direction="vertical" gap={12}>
        <Heading variant="heading4">
          {intl.formatMessage({
            id: '1QZv1fddQH',
            defaultMessage: 'Room Options',
            description: 'Heading for room options section',
          })}
        </Heading>
        <BodyTextBlock variant="medium" startIcon={<LineArrowsRightDownIcon />}>
          {pkg.roomType?.sizeSqm} m&sup2;
        </BodyTextBlock>
      </Group>
      {!!amenities?.length && <Group direction="vertical" gap={12}>
        <Heading variant="heading4">
          {intl.formatMessage({
            id: 'ZibXeAo7HM',
            defaultMessage: 'Room Amenities',
            description: 'Heading for room amenities section',
          })}
        </Heading>
        <List>
          {amenities.map(amenity => <BodyText
            key={amenity.description}
            as="li"
            variant="medium"
          >
            {amenity.description}
          </BodyText>)}
        </List>
      </Group>}
      {policyDescription && <Group direction="vertical" gap={12}>
        <Heading variant="heading4">
          {intl.formatMessage({
            id: 'vZDliWdpCN',
            defaultMessage: 'Room Policies',
            description: 'Heading for room policies section',
          })}
        </Heading>
        <MarkdownRender fontSize="medium" content={policyDescription} type="compact" />
      </Group>}
    </Group>
  )
}

export default FlashHotelAboutRoomModalTab
